import styled from 'styled-components';

export const EditorWrapper = styled.div`
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 2px solid #efefef;
  > * > * + * {
    margin-top: 1em;
  }

  .emoji.selected {
    outline: 2px solid blue;
  }

  height: auto;
  max-height: 200px;
  overflow: hidden;

  &:focus,
  &:focus-within {
    max-height: none;
    overflow: auto;
  }

  p {
    margin: 0;
    &:empty {
      margin-bottom: 20px;
      height: 1em;
    }
  }
`;

export const EditorToolbar = styled.div`
  position: relative;
  padding: 1px 18px 10px;
  margin: 0 -20px;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
  > * {
    display: inline-block;
  }
  > * + * {
    margin-left: 15px;
  }
  .button {
    color: #ccc;
    cursor: pointer;
    &[data-active='true'] {
      color: black;
    }
  }
`;

export const EmojiMenuWrapper = styled.div`
  padding-left: 20px;
  span {
    padding-left: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/ArkEdit/components.js